import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {WSPIconName} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {CurrentUsage} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/CurrentUsage';
import {SidebarLink} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/SidebarLink';
import {SidebarOrgSwitcher} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/SidebarOrgSwitcher';
import {SidebarSpaces} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/spaces/SidebarSpaces';
import {SettingsRoutes} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsPanel';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./WspSidebar.less');
const cx = classnames.bind(styles);

export enum WspSidebarLink
{
    HOME = 'HOME',
    SEARCH = 'SEARCH',
    DESIGNS = 'DESIGNS',
    TEMPLATES = 'TEMPLATES',
    SPACES = 'SPACES',
    APPLICATIONS = 'APPLICATIONS',
    LEARN = 'LEARN',
    HELP_CENTER = 'HELP_CENTER',
    VIDEO_TUTORIALS = 'VIDEO_TUTORIALS',
    DOCUMENTATION = 'DOCUMENTATION',
    CHAT_WITH_US = 'CHAT_WITH_US',
    CURRENT_USAGE = 'CURRENT_USAGE',
}

export interface IWspSidebarLink
{
    title:string;
    url?:string;
    icon?:WSPIconName;
    openInNewTab?:boolean;
    onClick?:(e:React.MouseEvent<HTMLElement>) => void;
}

@observer
export class WspSidebar extends React.Component<any, any>
{
    static wspSidebarLinks:{[key:string]:IWspSidebarLink} = {};

    componentWillMount():void
    {
        WspSidebar.wspSidebarLinks = {
            [WspSidebarLink.HOME]: {
                title: 'Home',
                url: paths.index(),
                icon: MDIcons.common.Home,
            },
            [WspSidebarLink.SEARCH]: {
                title: 'Search',
                url: paths.search(),
                icon: MDIcons.common.Search,
            },
            [WspSidebarLink.DESIGNS]: {
                title: 'Designs',
                url: paths.designs(),
                icon: MDIcons.common.PhotoFilter,
            },
            [WspSidebarLink.APPLICATIONS]: {
                title: 'Applications',
                url: paths.applications(),
                icon: MDIcons.common.Apps,
            },
            [WspSidebarLink.TEMPLATES]: {
                title: 'Templates',
                url: paths.templates(),
                icon: MDIcons.common.StarRate,
            },
            [WspSidebarLink.SPACES]: {
                title: 'Spaces',
                icon: MDIcons.common.FolderOpen,
                url: `${paths.settings()}/${SettingsRoutes.Spaces}`,
            },
            [WspSidebarLink.LEARN]: {
                title: 'Learn & Help',
                icon: MDIcons.common.Help,
                url: 'https://mintdata.com/docs/learn/',
                openInNewTab: true,
            },
            [WspSidebarLink.HELP_CENTER]: {
                title: 'Help Center',
                // url: paths.index(),
                // onClick: this._onClickHelpCenter,
                url: 'https://mintdata.com/docs/learn/',
                openInNewTab: true,
            },
            [WspSidebarLink.VIDEO_TUTORIALS]: {
                title: 'Video Tutorials',
                url: 'https://mintdata.com/videos/',
                openInNewTab: true,
            },
            [WspSidebarLink.DOCUMENTATION]: {
                title: 'Documentation',
                url: 'https://mintdata.com/docs/learn/',
                openInNewTab: true,
            },
            [WspSidebarLink.CHAT_WITH_US]: {
                title: 'Chat with us',
                // url: paths.index(),
                onClick: this._onClickChatWithUs,
            },
            [WspSidebarLink.CURRENT_USAGE]: {
                title: 'Current usage',
                icon: MDIcons.common.BarChart,
            },
        };
    }

    private _onClickHelpCenter = (e:React.MouseEvent<HTMLElement>) =>
    {
        e.preventDefault();

        // controllers.ui.mainPage.toggleHelpCenterVisibility();
        const {lx} = controllers.ui;

        lx.toggleLxFrameVisibility();
    };

    private _onClickChatWithUs = (e:React.MouseEvent<HTMLElement>) =>
    {
        e.preventDefault();
        controllers.analytics.intercom.show();
    };

    // componentDidMount()
    // {
    //     this.init();
    // }
    //
    // @action.bound
    // private init()
    // {
    //     controllers.data.projects.syncAllProjects().then(() =>
    //     {
    //         // controllers.analytics.main.trackEvent(AnalyticsEvents.WSP_PAGE_LOADED);
    //     });
    //
    //     controllers.data.organizations.syncAllOrganizations();
    // }

    render():JSX.Element
    {
        // do not remove: need for update SidebarLinks
        const {locationMatch} = rootState.ui.mainPage;

        const {isMobileMenuVisible} = rootState.ui.mainPage;

        return (
            <div className={cx(styles.sidebar, {isVisible: isMobileMenuVisible})}>

                <SidebarOrgSwitcher />

                <SidebarLink sidebarLink={WspSidebarLink.HOME} className={styles.mainLink} />
                <SidebarLink sidebarLink={WspSidebarLink.DESIGNS} className={styles.mainLink} />
                <SidebarLink sidebarLink={WspSidebarLink.APPLICATIONS} className={styles.mainLink} />
                <SidebarLink sidebarLink={WspSidebarLink.TEMPLATES} className={styles.mainLink} />

                <SidebarSpaces />

                <SidebarLink
                    sidebarLink={WspSidebarLink.LEARN}
                    className={styles.helpLinkBold}
                    iconClassName={styles.helpLinkIcon}
                />
                <SidebarLink sidebarLink={WspSidebarLink.HELP_CENTER} className={styles.helpLink} />
                <SidebarLink sidebarLink={WspSidebarLink.VIDEO_TUTORIALS} className={styles.helpLink} />
                <SidebarLink sidebarLink={WspSidebarLink.DOCUMENTATION} className={styles.helpLink} />
                <SidebarLink sidebarLink={WspSidebarLink.CHAT_WITH_US} className={styles.helpLink} />

                <div className={styles.spacer} />

                <CurrentUsage />

            </div>
        );
    }
}
